import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'brazeAnalyticsKey',
  initialState: null as string | null,
  reducers: {
    setBrazeAnalyticsKey(state, action) {
      return action.payload || null;
    },
  },
});

export const { setBrazeAnalyticsKey } = slice.actions;

export default slice.reducer;
